import React from "react";
import {
  Datagrid,
  DateField,
  List,
  ListButton,
  Pagination,
  TextField,
  TextInput,
  useRecordContext,
} from "react-admin";
import ImageEye from "@mui/icons-material/RemoveRedEye";
import SchoolIcon from "@mui/icons-material/School";

const filters = [
  <TextInput label="UserId" source="user_id" alwaysOn />,
  <TextInput
    source="first_name"
    alwaysOn
    name="first_name"
    label="First Name"
  />,
  <TextInput source="last_name" alwaysOn name="last_name" label="Last Name" />,
  <TextInput source="email" alwaysOn name="email" label="Email" />,
];

const LinkToThreads = () => {
  const record = useRecordContext();
  const { id } = record;
  return (
    <ListButton icon={<ImageEye />} to={`/threads/${id}`} label={"Threads"} />
  );
};

const LinkToLearning = () => {
  const record = useRecordContext();
  const { id } = record;
  return (
    <ListButton
      icon={<SchoolIcon />}
      to={`/users/${id}/learning`}
      label={"Learning"}
    />
  );
};

export const UsersList = () => {
  return (
    <List
      resource="users"
      filters={filters}
      perPage={50}
      pagination={
        <Pagination perPage={50} rowsPerPageOptions={[10, 25, 50, 100]} />
      }
    >
      <Datagrid>
        <TextField source="id" label="UserId" sortable={false} />
        <TextField source="first_name" label="First Name" sortable={false} />
        <TextField source="last_name" label="Last Name" sortable={false} />
        <TextField source="email" label="Email" sortable={false} />
        <TextField
          source="preferred_language"
          label="Language"
          sortable={false}
        />
        <DateField source="birth_date" label="Birth Date" sortable={false} />
        <LinkToThreads />
        <LinkToLearning />
      </Datagrid>
    </List>
  );
};
